import '../packages/ie11/src/scripts/distGlobal';
import '../packages/schemes/src/scripts/distGlobal';
import '../packages/utilities/src/scripts/distGlobal';
import '../packages/navigation/src/scripts/distGlobal';
import '../packages/breadcrumb/src/scripts/distGlobal';
import '../packages/header/src/scripts/distGlobal';
import '../packages/sidemenu/src/scripts/distGlobal';
